export default __webpack_public_path__ + "static/media/Banner-2.9ea42c12.jpg";